import { mapPromosDetails } from './mapPromosDetails';
import { mapPromosPreview } from './mapPromosPreview';
import { IPromoSearchItemSchema } from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { ISearchPromosResponse } from '../../repositories/newbuilding-promos/v1/search-promos';
import { IPromoDetailsById } from '../../types/promos/promoDetails';
import { IPromoItemById } from '../../types/promos/promos';

export const mapSearchPromos = (promosResponse: ISearchPromosResponse) => {
  const promos = promosResponse.promoSearchResult.promos;

  const previewById: IPromoItemById = {};
  const detailsById: IPromoDetailsById = {};

  const allIds = promos.map((promo: IPromoSearchItemSchema) => {
    previewById[promo.uniquePromoId] = mapPromosPreview(promo);
    detailsById[promo.uniquePromoId] = mapPromosDetails(promo);

    return promo.uniquePromoId;
  });

  return {
    allIds,
    previewById,
    detailsById,
  };
};
